import React, { Component } from 'react'
import * as DashboardError500Constant from './ErrorsAdminConstant'
import DashboardCleanersAdminHeader from '../../Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
import '../../../CSS/dashboard.css'

class CleanersAdminDashboardError500 extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<DashboardCleanersAdminHeader/>
                    <div className="ErrorDashboard">
                    <p>{DashboardError500Constant.Error500DashboardParagraph}</p>
				</div>
			</div>
		)
	}
}

export default CleanersAdminDashboardError500;